export const MULTI_ID_SUFFIX = 'multi';
export const VIRTUAL_ID_SUFFIX = 'virtual';
